import React from 'react';
import { useShop } from '../context/ShopContext';
import { ShieldCheck, Award, Truck, RefreshCw, Scale } from 'lucide-react';

export default function TrustSection() {
  const { trustPillarsData } = useShop();

  const getPillarIcon = (iconName, idx) => {
    switch (iconName) {
      case 'Truck': return <Truck size={28} color="#2874f0" />;
      case 'RefreshCw': return <RefreshCw size={28} color="#2874f0" />;
      case 'Award': return <Award size={28} color="#2874f0" />;
      default: return <ShieldCheck size={28} color="#2874f0" />;
    }
  };

  const dynamicPillars = Array.isArray(trustPillarsData) ? trustPillarsData : [];

  return (
    <section style={{
      padding: '24px 0',
      backgroundColor: '#f1f3f6'
    }}>
      <div className="container">
        
        {/* Flipkart White Card Trust Box */}
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '2px',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.1)',
          padding: '24px'
        }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '4px',
              color: '#2874f0',
              fontSize: '0.78rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              marginBottom: '4px'
            }}>
              <ShieldCheck size={16} /> 100% Genuine & Assured
            </span>
            <h2 style={{
              fontSize: '1.45rem',
              color: '#212121',
              fontWeight: 700
            }}>
              The M.L. Jewellers Assurance
            </h2>
            <p style={{
              color: '#878787',
              fontSize: '0.88rem',
              maxWidth: '560px',
              margin: '4px auto 0'
            }}>
              100% BIS Hallmarked Pure Gold, Insured Delivery, and Complete Bullion Rate Transparency.
            </p>
          </div>

          {/* Pillars Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: '16px'
          }}>
            {dynamicPillars.map((item, idx) => (
              <div
                key={item.id || idx}
                style={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #f0f0f0',
                  borderRadius: '2px',
                  padding: '16px',
                  display: 'flex',
                  gap: '14px',
                  alignItems: 'flex-start'
                }}
              >
                <div style={{
                  width: '46px',
                  height: '46px',
                  borderRadius: '50%',
                  backgroundColor: '#e8f0fe',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  {getPillarIcon(item.iconName, idx)}
                </div>

                <div>
                  <h3 style={{
                    fontSize: '0.96rem',
                    fontWeight: 700,
                    color: '#212121',
                    marginBottom: '4px'
                  }}>
                    {item.title}
                  </h3>
                  <p style={{
                    fontSize: '0.78rem',
                    color: '#878787',
                    lineHeight: 1.45
                  }}>
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
